import { render, staticRenderFns } from "./TaskMessage.vue?vue&type=template&id=08fb73c0&"
import script from "./TaskMessage.vue?vue&type=script&lang=ts&"
export * from "./TaskMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports